const FAQ_LIST = {
  LIST_PAGE_NO_FAQ_MSG: 'سوال متداولی برای این وبسایت ایجاد نشده است.',
  LIST_PAGE_HEADER_TITLE: 'سوالات متداول ویجت',
  ADD_BTN_LABEL: 'افزودن',
  LIST_PAGE_WEBSITE_SELECT_TITLE: 'نمایش برای وب سایت',
  FREQUEMTLY_AKED_Q_DESC:
    'با اضافه کردن سوالات متداول به این صفحه، یک سیستم پشتیبانی خودکار ایجاد می‌کنید. این کار به کاربران کمک می‌کند بدون تماس با تیم پشتیبانی، پاسخ سوالاتشان را بیابند و مشکلاتشان را خودشان حل کنند.',
};

export default FAQ_LIST;
